import ApiAcces from "@/shared/services/ApiAcces";
import type UserIntegrationToken from "../models/UserIntegrationToken";

export default class ClientIntegrationService extends ApiAcces {
  async getMyConnections(): Promise<UserIntegrationToken[]> {
    return (await this.api.get("api/integrations/me/connections")).data;
  }

  async disconnect(providerId: string): Promise<void> {
    await this.api.delete(`api/integrations/me/connections/${providerId}`);
  }

  async getAuthorizeUrl(providerId: string, returnUrl: string): Promise<string> {
    const base = import.meta.env.VITE_API_URL || "";
    const encoded = encodeURIComponent(returnUrl);
    const response = await this.api.get<{ authorizeUrl: string }>(
      `${base}api/integrations/connect/${providerId}?returnUrl=${encoded}`,
    );
    let url = response.data.authorizeUrl;

    // Backend workaround: returns query string without auth endpoint
    if (url.startsWith("?")) {
      url = `https://accounts.google.com/o/oauth2/v2/auth${url}`;
    }

    return url;
  }
}
